module.exports = __webpack_public_path__ + "img/Bg.f37d551b.png";